export { default as Paragraph } from './Paragraph';
